// extracted by mini-css-extract-plugin
module.exports = {"timeEntryModel":"style_timeEntryModel__3l3UF"};